var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6 33.1867C20.4759 33.1788 14.605 30.7425 10.2746 26.4121C5.94423 22.0817 3.50794 16.2108 3.5 10.0867C3.5 8.2567 4.22696 6.50166 5.52096 5.20766C6.81496 3.91366 8.57001 3.18669 10.4 3.18669C10.7875 3.18374 11.1744 3.21891 11.555 3.29169C11.923 3.34615 12.2847 3.43658 12.635 3.56169C12.8814 3.64814 13.1009 3.79739 13.2719 3.9947C13.4429 4.19201 13.5595 4.43054 13.61 4.68669L15.665 13.6867C15.7204 13.931 15.7137 14.1853 15.6456 14.4263C15.5775 14.6674 15.4501 14.8875 15.275 15.0667C15.08 15.2767 15.065 15.2917 13.22 16.2517C14.6975 19.493 17.2898 22.0959 20.525 23.5867C21.5 21.7267 21.515 21.7117 21.725 21.5167C21.9042 21.3416 22.1243 21.2142 22.3654 21.1461C22.6064 21.078 22.8607 21.0713 23.105 21.1267L32.105 23.1817C32.353 23.2392 32.5822 23.3589 32.7711 23.5295C32.9601 23.7 33.1025 23.9159 33.185 24.1567C33.3116 24.5127 33.407 24.8791 33.47 25.2517C33.5304 25.6287 33.5605 26.0099 33.56 26.3917C33.5323 28.2139 32.7849 29.9511 31.481 31.2242C30.177 32.4972 28.4223 33.2028 26.6 33.1867Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5 0.186523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1a9f75b43fb159d5f57aa6f2047bf821.svg";
export { ForwardRef as ReactComponent };